import EventBus from '../../../../shared/js/wirebox/event-bus'
import 'bootstrap/js/src/modal'
import jQuery from 'jquery'

EventBus.subscribe('run-modules',  () => {

    const container = jQuery('#survey-success-modal')
    if (container.length > 0) {
        container.modal('show')
    }
  
})